import { useEffect, useState } from "react";
import axios from "axios";
import { galleryImages as mockImages } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Gallery() {
  const [images, setImages] = useState(mockImages.map((url) => ({ url })));
  useEffect(() => {
    axios.get(`${API}/gallery`).then(r => { if (r.data?.length) setImages(r.data); }).catch(() => {});
  }, []);
  return (
    <section className="py-24 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-bold mb-3">Moments of Faith</div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a2d38] tracking-tight">
            Our church family <span className="text-[#c8a36a]">in action.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {images.map((img, i) => (
            <div
              key={img.id || i}
              className={`relative overflow-hidden rounded-md group ${
                i === 0 || i === 5 ? "col-span-2 row-span-2 aspect-square" : "aspect-square"
              }`}
            >
              <img
                src={img.url}
                alt={img.caption || `Moment ${i + 1}`}
                className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a2d38]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
